import { Box } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { ContaForm, PagarContaForm } from "core/features/conta/typings";
import { Control, UseFormSetValue } from "react-hook-form";
import Field from "components/Input/Field";
import InputToggleContent from "components/Input/InputToggleContent";
import ButtonAnexarArquivos from "components/Button/ButtonAnexarArquivos";
import Anexos from "components/Anexos";
import useUploadAnexo from "core/features/arquivo/useUploadAnexo";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

interface AnexarArquivosProps {
  control: Control<ContaForm, object> | Control<PagarContaForm, object>;
  form?: ContaForm | PagarContaForm;
  setValue: UseFormSetValue<ContaForm>;
  pushArquivoRemovido?: (id: string) => any;
}
function AnexarArquivos({
  control,
  form,
  setValue,
  pushArquivoRemovido,
}: AnexarArquivosProps) {
  const files = form?.files;
  const [disableButtonAnexar, setDisabledButtonAnexar] = useState(false);

  return (
    <Box as={Row} mb={2}>
      <Box as={Col} sm={24}>
        <Field
          shouldUnregister
          control={control}
          name="anexarArquivos"
          render={({ field }) => (
            <InputToggleContent
              label="Anexar arquivos"
              active={field.value}
              size="sm"
              onToggle={(checked) => {
                field.onChange(checked);
                if (files?.length && !checked) {
                  files.forEach((file) => {
                    if (!(file instanceof File))
                      pushArquivoRemovido?.(file.id!);
                  });
                }
              }}
            >
              <Box flex={1}>
                <ButtonAnexarArquivos
                  accept="image/*, application/pdf, video/*, .csv, .xlsx"
                  maxFileSizeMb={200}
                  currentFilesLength={form?.files?.length || 0}
                  variant="ghost"
                  disabled={disableButtonAnexar}
                  onAnexar={(files) => {
                    if (files) {
                      const currentAnexos = form?.files;
                      files.forEach((file) => {
                        if (file instanceof File) {
                          (file as any).key = uuidv4();
                        }
                      });

                      setValue(
                        "files",
                        currentAnexos
                          ? [...currentAnexos, ...files]
                          : [...files]
                      );
                    }
                  }}
                />
              </Box>

              <Box gap="16px" mt="auto" h="fit-content" py={2} flexDir="column">
                {form?.files?.length ? (
                  <Anexos
                    onStartUploadMutation={() => setDisabledButtonAnexar(true)}
                    onFinishUploadMutation={() =>
                      setDisabledButtonAnexar(false)
                    }
                    autoUploadMutation={useUploadAnexo}
                    selectTipoAnexoConta
                    trackRemove={(id) => {
                      if (id) {
                        pushArquivoRemovido?.(id);
                      }
                    }}
                    setValue={(files) => {
                      setValue(
                        "files",
                        files?.map((file) =>
                          Object.assign(file, {
                            nome:
                              file instanceof File || Reflect.has(file, "name")
                                ? file.name
                                : file.nome!,
                          })
                        ) || []
                      );
                    }}
                    anexos={
                      form.files?.map((file) =>
                        file instanceof File
                          ? file
                          : { ...file, name: file.nome }
                      ) || undefined
                    }
                  />
                ) : null}
              </Box>
            </InputToggleContent>
          )}
        />
      </Box>
    </Box>
  );
}

export default AnexarArquivos;
